/**
 * @module actions/tasks
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Get pending report merges for specified orderId
 * @return {Promise} Axios promise
 */
export function getPendingMerges (orderId) {
  let url = API_URL + `/Report/ManualMerge/${orderId}`
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Match a report and order
 * @return {Promise} Axios promise
 */
export function reportOrderMatch (data) {
  let url = API_URL + '/Report/ManualMerge'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Cancel a report merge request i.e. create the report as a new order
 * @return {Promise} Axios promise
 */
export function cancelReportOrder (data) {
  let url = API_URL + '/Report/CancelMergeRequest'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/reports.js